module.exports = __webpack_public_path__ + "img/default.2ff08c69.png";